import { render, staticRenderFns } from "./CardLayoutCardSkeleton.vue?vue&type=template&id=685e6926&"
import script from "./CardLayoutCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./CardLayoutCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports